import React, { useState,useEffect } from 'react'
import {
    Box,
    Button,
    Grid,
    Typography,
    IconButton,
    InputAdornment,
    Input,
    Card,
  } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import DID_Thumbnail from "../../../assets/VideoSettings_DIDThumbnail.png";
import VideoGen_Thumbnail from "../../../assets/VideoSettings_VideoGenThumbnail.png";
import { useWorkspace } from "../../../contexts/WorkspaceContext";
import { fetchCaptionFont, fetchLanguages, fetchVoices, VideoGenAPISettings } from './VideoGenSettings/VideoGenAPISettings';
import HeygenThemeImage from "../../../assets/Heygen/Heygen_Theme.png";

const SelectVideoGenetrationPlatform = () => {
    const [videoGenerationPlatform,setVideoGenerationPlatform] = useState("Avatar");
    const navigate = useNavigate();
    const {setMinDImensionPixels,setSelectedVideoGenerationPlatform,setShowVideoSettings,setShowVideoGenSettings,selectedVideoGenerationPlatform, userMediaSettings, genVideoLanguage, genVideoVoice, setGenVideoLanguage, setGenVideoAudioSettingsLoading, setGenVideoVoice,  setGenVideoVoicesLoading,setCaptionFontForVideoGen, CaptionFontForVideoGen} = useWorkspace();

    const handlePlatformSelection = (platform) => {
        setVideoGenerationPlatform(platform);
        setSelectedVideoGenerationPlatform(platform);
        
        // Navigate to videoGenerate page for multiple avatar videos
        if(platform === "multipleAvatar"){
            const isLoggedIn = localStorage.getItem("isLoggedIn");
            if(isLoggedIn){
                navigate("/videoGenerate");
            } else {
                alert("Please login to access Multiple Avatar Videos feature");
            }
        }
        // if(platform === "presenter"){
        //     setShowVideoSettings(true);
        //     setTimeout(() => {
        //         setShowVideoGenSettings(false);
        //       }, 500);
            
            
        //     // trackModalOpen(true)
        //   }
        //   else if(platform === "voice-over"){
        //     setShowVideoGenSettings(true);
        //     setTimeout(() => {
        //         setShowVideoSettings(false);
        //       }, 500);
            
        //     // trackModalOpen(true)
        //   }
    }

     useEffect(() => {
        // if (genVideoLanguage || genVideoVoice) {
        //   VideoGenAPISettings(
        //     setGenVideoLanguage,
        //     setGenVideoAudioSettingsLoading,
        //     setGenVideoVoice,
        //     setGenVideoVoicesLoading,
        //     setCaptionFontForVideoGen
        //   );
        // }
        if(!genVideoLanguage?.length){
            fetchLanguages(setGenVideoLanguage,setGenVideoAudioSettingsLoading)
        }
         if(!genVideoVoice?.length){
            fetchVoices(setGenVideoVoice, setGenVideoVoicesLoading)
        }
          if(!CaptionFontForVideoGen?.length){
            fetchCaptionFont(setCaptionFontForVideoGen)
        }
      }, []);

    useEffect(() => {
      setVideoGenerationPlatform(selectedVideoGenerationPlatform)
    }, [selectedVideoGenerationPlatform])

    // useEffect(()=>{
    //   if(userMediaSettings){
    //     setMinDImensionPixels(userMediaSettings[1]?.settings?.typeOneVideoSettings?.minDimensionPixels)
    //   }
    // },[userMediaSettings])
    
  return (
    <div style={{width:'100%',height:'100%',paddingRight:'20px',paddingTop:'20px',maxWidth:'686px'}}>
        <Typography
            variant="h6"
            gutterBottom
            style={{
              fontSize: "16px",
              fontWeight: "500",
              width: "143px",
              height: "20px",
              marginBottom: "20px",
            }}
          >
           Select Video Type
          </Typography>
          <Box sx={{width:'100%',maxWidth:'956px',height:'400px',display:'flex',justifyContent:'center',gap:'20px',flexWrap:'wrap'}}>
              <Box sx={{
                  width: '308px', maxWidth: '308px', height: '289px', padding: '12px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRadius: '8px', backgroundColor: videoGenerationPlatform === "Avatar" ? '#3a3f69' : '#30355f',               
                  // "&:hover": {
                  //   backgroundColor: "#373E6D", 
                  //   border:" 1px solid #373E6D"
                  // },
                  border: `1px solid ${videoGenerationPlatform === "Avatar" ? '#cac4d0' : 'transparent'}`,
                  cursor: 'pointer'
              }}
                  onClick={() => handlePlatformSelection("Avatar")}
              >
                  <img src={HeygenThemeImage} style={{ borderRadius: '6px',width:'284px',height:'161.51px', margin: '0 auto' }} alt=""/>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>Avatar videos</Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: '400',color:'rgba(255,255,255,0.8)' }}>Generates a video with a custom avatar presenting content, with customizable backgrounds, voice, and language.</Typography>
              </Box>
              <Box sx={{
                  width: '308px', maxWidth: '308px', height: '289px', padding: '12px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRadius: '8px', backgroundColor: videoGenerationPlatform === "multipleAvatar" ? '#3a3f69' : '#30355f',               
                  // "&:hover": {
                  //   backgroundColor: "#373E6D", 
                  //   border:" 1px solid #373E6D"
                  // },
                  border: `1px solid ${videoGenerationPlatform === "multipleAvatar" ? '#cac4d0' : 'transparent'}`,
                  cursor: 'pointer'
              }}
                  onClick={() => handlePlatformSelection("multipleAvatar")}
              >
                  <img src={HeygenThemeImage} style={{ borderRadius: '6px',width:'284px',height:'161.51px', margin: '0 auto' }} alt=""/>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>Multiple Avatar Videos</Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: '400',color:'rgba(255,255,255,0.8)' }}>Create videos with multiple avatars in a timeline, each with their own script, voice, and background settings.</Typography>
              </Box>
               <Box sx={{
                  width: '308px', maxWidth: '308px', height: '289px', padding: '12px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRadius: '8px', backgroundColor: videoGenerationPlatform === "veo" ? '#3a3f69' : '#30355f',               
                  // "&:hover": {
                  //   backgroundColor: "#373E6D", 
                  //   border:" 1px solid #373E6D"
                  // },
                  border: `1px solid ${videoGenerationPlatform === "veo" ? '#cac4d0' : 'transparent'}`,
                  cursor: 'pointer'
              }}
                  onClick={() => handlePlatformSelection("veo")}
              >
                  <img src={VideoGen_Thumbnail} style={{ borderRadius: '6px',width:'284px',height:'161.51px' }} alt=""/>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>Voice-over videos</Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: '400',color:'rgba(255,255,255,0.8)' }}>Generates a video with motion graphics and a voice-over with customizable captions, voice, language, and aspect ratio</Typography>
              </Box>
          </Box>
    </div>
  )
}

export default SelectVideoGenetrationPlatform